import { createReducer, on } from '@ngrx/store';
import * as AuthActions from './auth.actions';
import { initialAuthState } from './auth.state';

export const authReducer = createReducer(
  initialAuthState,
  on(AuthActions.setToken, (state, { token }) => ({ ...state, token })),
  on(AuthActions.setUser, (state, { user }) => ({ ...state, user })),
  on(AuthActions.setSelectedAgency, (state, { agency }) => ({ ...state, selectedAgency: agency })),
  on(AuthActions.clearSession, () => ({ ...initialAuthState })),
);
